var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-wrapper"},[_c('button',{staticClass:"remove-btn",attrs:{"title":"Remove widget"},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('remove')}}},[_c('i',{staticClass:"fa fa-times"})]),_c('div',{staticClass:"widget-content drag-handle"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }